module.exports = __webpack_public_path__ + "img/nodeiconchoose.2ed32bca.svg";